import { type ResultSectionAnalyticData } from '../../../../../../common/analytics/events';
import { type SearchItems } from '../../../result-types';

const unavailable = 'UNAVAILABLE';
const defaultItemLimit = 10;

export const transformResults = (searchItems: SearchItems): ResultSectionAnalyticData[] => {
	return searchItems.sections.map((section) => ({
		results: section.searchResults
			.slice(0, section?.resultLimit || defaultItemLimit)
			.map((item) => ({
				containerId: item.containerId || unavailable,
				isRecentResult: !!item.isRecentResult,
				resultContentId: item.id,
				resultType: section.id,
			})),
		sectionId: section.id,
	}));
};
